import { arrayOf, bool, func, oneOfType, shape, string } from 'prop-types';
import React from 'react';

import Table from '../../generic/Table';
import { basicCampaignShape, reactTableColumnShape } from '../../prop-types';
import withUsers from '../../users/withUsers/with-users';
import ExportAllCampaigns from '../ExportAllCampaigns';

function List({ data, columns, dump, exportParams, displayExportButton }) {
  return (
    <Table
      data={data}
      columns={columns}
      onDownload={dump ? () => dump(exportParams) : undefined}
      minRows={2}
    >
      {displayExportButton && (
        <ExportAllCampaigns searchParams={exportParams} className="ml-3" />
      )}
    </Table>
  );
}

List.propTypes = {
  data: arrayOf(basicCampaignShape.isRequired).isRequired,
  columns: arrayOf(reactTableColumnShape).isRequired,
  exportParams: shape({
    status: oneOfType([string.isRequired, arrayOf(string.isRequired)]),
  }),
  dump: func,
  displayExportButton: bool,
};

List.defaultProps = {
  exportParams: undefined,
  dump: undefined,
  displayExportButton: false,
};

export default withUsers({})(List);
